module.exports = __webpack_public_path__ + "img/financement_img.29dff7f7.png";